<template>
  <v-row>
    <v-col v-if="isRecurringEvent" cols="12">
      <RecurringEvent />
    </v-col>
    <v-col cols="12">
      <BulkEventInsertion
        v-if="
          getIsRecurringEvent &&
          (getSelectedDateToTickets?.includes('all') ||
            getSelectedDateToTickets?.length > 1)
        "
      />
      <ItemsToSale
        v-if="
          (getIsRecurringEvent &&
            !getSelectedDateToTickets?.includes('all') &&
            getSelectedDateToTickets?.length === 1) ||
          !getIsRecurringEvent
        "
        :icon="'mdi-ticket-outline'"
        :title="$t('new-event.ticket-management.tickets.title')"
        :isOpen="true"
        :fields="ticketFields"
        :list="getTicketListFiltered"
        :allTickets="getTicketList"
        :subtitle="subtitleSections.formattedSubtitleTicket"
        :newAction="newActionsTickets"
        :newActionText="
          $t('new-event.ticket-management.tickets.add-new-ticket')
        "
        :actions="actionsTickets"
        :addBtn="addNewPaidTicket"
        :saveBtn="saveBtn"
      />
      <div class="my-7" v-if="getIsRecurringEvent">
        <h4>{{ $t("new-event.ticket-management.product-recharges-title") }}</h4>
        <small>{{
          $t("new-event.ticket-management.product-recharges-subtitle")
        }}</small>
      </div>
      <ItemsToSale
        :icon="'mdi-card-plus'"
        :title="$t('new-event.ticket-management.recharges.title')"
        :isOpen="getRechargeList && getRechargeList?.length > 0"
        :subtitle="subtitleSections.formattedSubtitleRecharge"
        :fields="rechargeFields"
        :list="getRechargeList"
        :addBtn="addNewRecharge"
        :newAction="newActionsRecharge"
        :actions="actionsRecharge"
        :saveBtn="saveBtn"
      />
      <ItemsToSale
        :icon="'mdi-tshirt-crew'"
        :title="$t('new-event.ticket-management.products.title')"
        :isOpen="getProductList && getProductList?.length > 0"
        :subtitle="subtitleSections.formattedSubtitleProduct"
        :fields="productFields"
        :list="getProductList"
        :addBtn="addNewProduct"
        :newAction="newActionsProduct"
        :actions="actionsProduct"
        :saveBtn="saveBtn"
      />
    </v-col>
    <ModalTicketSettings
      :dialog.sync="dialogTicketSettings"
      @close="closeItemModal('dialogTicketSettings')"
      :eventData="selectedItem"
      @update:eventData="
        updateItemData(
          $event,
          'getTicketList',
          'setTicketList',
          'dialogTicketSettings',
          $t('new-event.ticket-management.tickets.update-success')
        )
      "
    />
    <ModalRechargeSettings
      :dialog.sync="dialogRechargeSettings"
      @close="closeItemModal('dialogRechargeSettings')"
      :eventData="selectedItem"
      @update:eventData="
        updateItemData(
          $event,
          'getRechargeList',
          'setRechargeList',
          'dialogRechargeSettings',
          $t('new-event.ticket-management.recharges.update-success')
        )
      "
    />
    <ModalProductSettings
      :dialog.sync="dialogProductSettings"
      @close="closeItemModal('dialogProductSettings')"
      :eventData="selectedItem"
      @update:eventData="
        updateItemData(
          $event,
          'getProductList',
          'setProductList',
          'dialogProductSettings',
          $t('new-event.ticket-management.products.update-success')
        )
      "
    />
    <ConfirmAction
      :dialog.sync="confirmDelete"
      :title="confirmTitle"
      :subtitle="confirmSubtitle"
      @action="removeItem(itemToDelete)"
      @close="cancelRemove"
    />
  </v-row>
</template>
<script>
import ConfirmAction from "./EventSettingsModal/ConfirmAction.vue";
import ItemsToSale from "./ItemsToSale.vue";
import ModalTicketSettings from "./EventSettingsModal/ModalTicketSettings.vue";
import ModalRechargeSettings from "./EventSettingsModal/ModalRechargeSettings.vue";
import ModalProductSettings from "./EventSettingsModal/ModalProductSettings.vue";
import BulkEventInsertion from "./BulkEventInsertion.vue";
import RecurringEvent from "./RecurringEvent.vue";
import { getTranslatedText } from "@/utils";
import { mapGetters, mapActions, mapMutations } from "vuex";
import dayjs from "dayjs";

export default {
  name: "TicketManagement",
  components: {
    ItemsToSale,
    ModalTicketSettings,
    ModalRechargeSettings,
    ModalProductSettings,
    ConfirmAction,
    RecurringEvent,
    BulkEventInsertion,
  },
  data() {
    return {
      dialogTicketSettings: false,
      dialogRechargeSettings: false,
      dialogProductSettings: false,
      selectedItem: {},

      confirmDelete: false,
      confirmTitle: "",
      confirmSubtitle: "",
      itemToDelete: null,
    };
  },
  computed: {
    ...mapGetters([
      "getEventSectorData",
      "getTicketList",
      "getRechargeList",
      "getProductList",
      "getEventBasicData",
      "getTicketList",
      "getTicketListFiltered",
      "getSelectedDateToTickets",
      "getIsRecurringEvent",
      "getAllDatesOfTickets",
    ]),
    isRecurringEvent() {
      return this.getEventBasicData?.frequency === "RECORRENTE";
    },
    datesToSelect() {
      return this.getAllDatesOfTickets?.map(date => {
        return {
          value: date,
          text: dayjs(date).format("DD/MM/YYYY HH:mm"),
        };
      });
    },
    subtitleSections() {
      return {
        formattedSubtitleTicket: this.$t(
          "new-event.ticket-management.formatted-subtitle-ticket"
        ),
        formattedSubtitleRecharge: this.$t(
          "new-event.ticket-management.formatted-subtitle-recharge"
        ),
        formattedSubtitleProduct: this.$t(
          "new-event.ticket-management.formatted-subtitle-product"
        ),
        formattedSubtitleCombo: this.$t(
          "new-event.ticket-management.formatted-subtitle-combo"
        ),
      };
    },
    eventSectorData() {
      return this.getEventSectorData?.sectors?.map(item => {
        return {
          value: item.idsetor,
          text: getTranslatedText(item.descricao),
        };
      });
    },
    ticketFields() {
      return [
        {
          text: this.$t("new-event.ticket-management.tickets.fields.title"),
          type: "text",
          align: "start",
          value: "name",
          hasRules: true,
          maxlength: "65",
        },
        {
          text: this.$t("new-event.ticket-management.tickets.fields.sector"),
          type: "select",
          align: "start",
          value: "sector",
          items: this.eventSectorData,
          exist: !this.getEventSectorData?.hasSector,
          hasRules: true,
        },
        {
          text: this.$t("new-event.recurring-event.data"),
          type: "select",
          align: "end",
          value: "ticketDate",
          exist: !this.getIsRecurringEvent,
          allowedDates: true,
          hasRules: true,
          items: this.datesToSelect,
        },
        {
          text: this.$t("new-event.ticket-management.tickets.fields.batch"),
          items: this.batchItems(1),
          itemsSecondary: this.batchItems(10),
          type: "select",
          align: "end",
          value: "batch",
          hasRules: false,
          cols: 1,
        },
        {
          text: this.$t("new-event.ticket-management.tickets.fields.price"),
          type: "money",
          align: "end",
          value: "price",
          hasRules: true,
          selectContent: true,
          minWidth: "100px",
        },
        {
          text: this.$t("new-event.ticket-management.tickets.fields.quantity"),
          type: "number",
          align: "end",
          value: "quantity",
          hasRules: true,
          cols: 1,
          selectContent: true,
          minWidth: "100px",
        },
        {
          text: "Status",
          items: this.status,
          type: "select",
          align: "end",
          value: "status",
          hasRules: false,
        },
      ];
    },
    rechargeFields() {
      return [
        {
          text: this.$t("new-event.ticket-management.recharges.fields.value"),
          type: "money",
          align: "end",
          value: "price",
          hasRules: true,
          selectContent: true,
        },
        {
          text: this.$t(
            "new-event.ticket-management.recharges.fields.sales-start"
          ),
          type: "date",
          align: "end",
          value: "salesPeriodStart",
          hasRules: true,
          exist: this.getIsRecurringEvent,
        },
        {
          text: this.$t(
            "new-event.ticket-management.recharges.fields.sales-end"
          ),
          type: "date",
          align: "end",
          value: "salesPeriodEnd",
          hasRules: true,
          exist: this.getIsRecurringEvent,
        },
        {
          text: this.$t(
            "new-event.ticket-management.recharges.fields.quantity"
          ),
          type: "number",
          align: "end",
          value: "quantity",
          hasRules: true,
          cols: 2,
          selectContent: true,
        },
        {
          text: "Status",
          items: this.status,
          type: "select",
          align: "end",
          value: "status",
          hasRules: false,
        },
      ];
    },
    productFields() {
      return [
        {
          text: this.$t("new-event.ticket-management.products.fields.images"),
          type: "image",
          align: "end",
          value: "images",
          hasRules: true,
        },
        {
          text: this.$t("new-event.ticket-management.products.fields.title"),
          type: "text",
          align: "end",
          value: "name",
          hasRules: true,
          maxlength: "65",
        },
        {
          text: this.$t("new-event.ticket-management.products.fields.price"),
          type: "money",
          align: "end",
          value: "price",
          hasRules: true,
          selectContent: true,
        },
        {
          text: this.$t("new-event.ticket-management.products.fields.quantity"),
          type: "number",
          align: "end",
          value: "quantity",
          hasRules: false,
          cols: 2,
          selectContent: true,
        },
        {
          text: "Status",
          items: this.status,
          type: "select",
          align: "end",
          value: "status",
          hasRules: false,
        },
      ];
    },
    newActionsTickets() {
      return [
        {
          text: this.$t("new-event.ticket-management.tickets.new-actions.paid"),
          action: () => {
            this.addNewPaidTicket();
          },
        },
        {
          text: this.$t("new-event.ticket-management.tickets.new-actions.free"),
          action: () => {
            this.addNewCourtesyTicket();
          },
        },
        {
          text: this.$t(
            "new-event.ticket-management.tickets.new-actions.gratuity"
          ),
          action: () => {
            this.addNewGratuityTicket();
          },
        },
        {
          text: this.$t(
            "new-event.ticket-management.tickets.new-actions.reservation"
          ),
          action: () => {
            this.addNewReservationTicket();
          },
        },
      ];
    },
    newActionsRecharge() {
      return [
        {
          text: this.$t(
            "new-event.ticket-management.recharges.new-actions.new"
          ),
          action: () => {
            this.addNewRecharge();
          },
        },
      ];
    },
    newActionsProduct() {
      return [
        {
          text: this.$t("new-event.ticket-management.products.new-actions.new"),
          action: () => {
            this.addNewProduct();
          },
        },
      ];
    },
    actionsTickets() {
      return [
        {
          text: this.$t("new-event.ticket-management.tickets.actions.double"),
          icon: "mdi-content-copy",
          action: item => {
            this.doubleTicket(item);
          },
        },
        {
          text: this.$t("new-event.ticket-management.tickets.actions.half"),
          icon: "mdi-ticket-confirmation-outline",
          action: item => {
            this.addNewHalfTicket(item);
          },
        },
        {
          text: this.$t(
            "new-event.ticket-management.tickets.actions.next-batch"
          ),
          icon: "mdi-folder-plus",
          action: item => {
            this.addTicketNextBatch(item);
          },
        },
        {
          text: this.$t("new-event.ticket-management.tickets.actions.settings"),
          icon: "mdi-cog",
          action: item => {
            this.selectedItem = item;
            this.dialogTicketSettings = true;
          },
        },
        {
          text: this.$t("new-event.ticket-management.tickets.actions.remove"),
          icon: "mdi-delete",
          action: item => {
            this.confirmRemove(item);
          },
        },
      ];
    },
    actionsRecharge() {
      return [
        {
          text: this.$t(
            "new-event.ticket-management.recharges.actions.settings"
          ),
          icon: "mdi-cog",
          action: item => {
            this.selectedItem = item;
            this.dialogRechargeSettings = true;
          },
        },
        {
          text: this.$t("new-event.ticket-management.recharges.actions.remove"),
          icon: "mdi-delete",
          action: item => {
            this.confirmRemove(item);
          },
        },
      ];
    },
    actionsProduct() {
      return [
        {
          text: this.$t("new-event.ticket-management.products.actions.double"),
          icon: "mdi-content-copy",
          action: item => {
            this.doubleProduct(item);
          },
        },
        {
          text: this.$t(
            "new-event.ticket-management.products.actions.settings"
          ),
          icon: "mdi-cog",
          action: item => {
            this.selectedItem = item;
            this.dialogProductSettings = true;
          },
        },
        {
          text: this.$t("new-event.ticket-management.products.actions.remove"),
          icon: "mdi-delete",
          action: item => {
            this.confirmRemove(item);
          },
        },
      ];
    },
    isEditing() {
      return this.$route.path.includes("editar-evento");
    },
    status() {
      return [
        {
          text: this.$t("new-event.settings.status.active"),
          value: "ATIVO",
        },
        {
          text: this.$t("new-event.settings.status.inactive"),
          value: "INATIVO",
        },
        {
          text: this.$t("new-event.settings.status.sold-out"),
          value: "ESGOTADO",
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      "addNewPaidTicket",
      "removeTicket",
      "doubleTicket",
      "addNewHalfTicket",
      "addNewCourtesyTicket",
      "addNewGratuityTicket",
      "addNewReservationTicket",
      "addNewRecharge",
      "addNewProduct",
      "removeRecharge",
      "removeProduct",
      "doubleProduct",
      "addTicketNextBatch",
      "updateEvent",

      "showSnackbarSuccess",
      "showSnackbarError",
    ]),
    ...mapMutations(["setTicketList", "setProductList", "setRechargeList"]),
    closeItemModal(modal) {
      this[modal] = false;
      this.selectedItem = {};
    },
    updateItemData(data, listGetter, listSetter, modal, successMessage) {
      const updatedList = this[listGetter].map(item =>
        item?.idproduto_variacao === data?.idproduto_variacao ? data : item
      );

      this[listSetter](updatedList);
      this.showSnackbarSuccess(successMessage);
      this.closeItemModal(modal);
    },
    confirmRemove(data) {
      this.confirmDelete = true;
      this.itemToDelete = data;

      const ticketName = data.name
        ? `"${data.name}"`
        : this.$t("common.no-ticket");
      const productName = data.name
        ? `"${data.name}"`
        : this.$t("common.no-product");
      const rechargeName = data.price
        ? `"${data.price}"`
        : this.$t("common.no-price");

      if (data.type === "INGRESSO") {
        this.confirmTitle = this.$t(
          "new-event.ticket-management.tickets.delete-title"
        );
        this.confirmSubtitle = `${this.$t(
          "new-event.ticket-management.tickets.delete-confirm"
        )} <strong>${ticketName}</strong>?`;
      } else if (data.type === "RECARGA") {
        this.confirmTitle = this.$t(
          "new-event.ticket-management.recharges.delete-title"
        );
        this.confirmSubtitle = `${this.$t(
          "new-event.ticket-management.recharges.delete-confirm"
        )} <strong>${rechargeName}</strong>?`;
      } else if (data.type === "PRODUTO") {
        this.confirmTitle = this.$t(
          "new-event.ticket-management.products.delete-title"
        );
        this.confirmSubtitle = `${this.$t(
          "new-event.ticket-management.products.delete-confirm"
        )} <strong>${productName}</strong>?`;
      }
    },
    cancelRemove() {
      this.confirmDelete = false;
      this.itemToDelete = null;
    },
    async removeItem(item) {
      if (item.type === "INGRESSO") {
        const maxBatch = Math.max(
          ...this.getTicketList.map(ticket => ticket.batch)
        );
        const isCurrentTicketLinkedToPreviousBatch = this.getTicketList.some(
          ticket => ticket.previousBatch === item.idproduto_variacao
        );

        if (isCurrentTicketLinkedToPreviousBatch) {
          this.showSnackbarError(
            this.$t(
              "new-event.ticket-management.tickets.error-remove-with-batch",
              {
                batch: item.batch,
                maxBatch: maxBatch,
              }
            )
          );
          this.confirmDelete = false;
          return;
        }

        await this.removeTicket(item);
      } else if (item.type === "RECARGA") {
        await this.removeRecharge(item);
      } else if (item.type === "PRODUTO") {
        await this.removeProduct(item);
      }

      this.confirmDelete = false;
      this.itemToDelete = null;
    },
    batchItems(number) {
      const items = [
        {
          text: this.$t("new-event.ticket-management.tickets.no-batch"),
          value: 0,
        },
      ];
      for (let i = 1; i <= number; i++) {
        items.push({ text: i.toString(), value: i });
      }
      return items;
    },
    async saveBtn() {
      await this.updateEvent();
      this.dialogTicketSettings = false;
      this.selectedItem = {};
    },
  },
};
</script>
